/* Auto-generated by scripts/generate-schema-model.mts — do not edit. */
import pacs_008 from './pacs_008.json';
import pacs_002 from './pacs_002.json';
import pacs_004 from './pacs_004.json';
import pacs_009 from './pacs_009.json';
import pacs_028 from './pacs_028.json';
import pain_001 from './pain_001.json';
import pain_002 from './pain_002.json';
import pain_008 from './pain_008.json';
import pain_013 from './pain_013.json';
import pain_014 from './pain_014.json';
import camt_056 from './camt_056.json';
import camt_029 from './camt_029.json';
import camt_052 from './camt_052.json';
import camt_053 from './camt_053.json';
import camt_054 from './camt_054.json';
import camt_055 from './camt_055.json';
import camt_026 from './camt_026.json';
import camt_087 from './camt_087.json';
import acmt_023 from './acmt_023.json';
import acmt_024 from './acmt_024.json';
import type { SchemaModel } from '@/lib/schema/types';

export const SCHEMA_MODELS: Record<string, SchemaModel> = {
  'pacs.008': pacs_008 as SchemaModel,
  'pacs.002': pacs_002 as SchemaModel,
  'pacs.004': pacs_004 as SchemaModel,
  'pacs.009': pacs_009 as SchemaModel,
  'pacs.028': pacs_028 as SchemaModel,
  'pain.001': pain_001 as SchemaModel,
  'pain.002': pain_002 as SchemaModel,
  'pain.008': pain_008 as SchemaModel,
  'pain.013': pain_013 as SchemaModel,
  'pain.014': pain_014 as SchemaModel,
  'camt.056': camt_056 as SchemaModel,
  'camt.029': camt_029 as SchemaModel,
  'camt.052': camt_052 as SchemaModel,
  'camt.053': camt_053 as SchemaModel,
  'camt.054': camt_054 as SchemaModel,
  'camt.055': camt_055 as SchemaModel,
  'camt.026': camt_026 as SchemaModel,
  'camt.087': camt_087 as SchemaModel,
  'acmt.023': acmt_023 as SchemaModel,
  'acmt.024': acmt_024 as SchemaModel,
};
